export const amountToWords = (amount: number): string => {
        if (amount === 0) return 'Zero Rupees Only';

        const ones = [
            '', 'One', 'Two', 'Three', 'Four', 'Five',
            'Six', 'Seven', 'Eight', 'Nine', 'Ten',
            'Eleven', 'Twelve', 'Thirteen', 'Fourteen',
            'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
        ];

        const tens = [
            '', '', 'Twenty', 'Thirty', 'Forty',
            'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
        ];

        const numToWords = (num: number): string => {
            if (num < 20) return ones[num];
            if (num < 100)
                return `${tens[Math.floor(num / 10)]} ${ones[num % 10]}`.trim();
            if (num < 1000)
                return `${ones[Math.floor(num / 100)]} Hundred ${numToWords(num % 100)}`.trim();
            if (num < 100000)
                return `${numToWords(Math.floor(num / 1000))} Thousand ${numToWords(num % 1000)}`.trim();
            if (num < 10000000)
                return `${numToWords(Math.floor(num / 100000))} Lakh ${numToWords(num % 100000)}`.trim();
            return `${numToWords(Math.floor(num / 10000000))} Crore ${numToWords(num % 10000000)}`.trim();
        };

        return `${numToWords(Math.floor(amount))} Rupees Only`;
    }